import React, { useRef, useState } from 'react'
import { Form,Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { BsShieldFillCheck } from "react-icons/bs";
import { HiPlusCircle } from "react-icons/hi";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from 'react-redux'
import key from '../../key';
import OtpVerification from './OtpVerification';

function UserCard() {
    const fileInputRef = useRef(null)
    const { user } = useSelector(state => state.user)
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleAddPhoto = (file) => {
        // TODO: Implement logic to add a new photo to the user's album
    };


    const handleFileInputChange = (event) => {
        const file = event.target.files[0];
        handleAddPhoto(file);
        // TODO: Implement logic to handle the selected file
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Verifying Your Account</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <OtpVerification />
                </Modal.Body>
            </Modal>
            <div className="card card-container" >
                <div className="user-photo-container">
                    {
                        user?.photos[0] ? (
                            <img className="user-photo" src={`${key}/images/${user?.photos[0]?.url}`} alt="Card-cap" />
                        ) :
                            (
                                <img className="user-photo" src="https://www.allianceplast.com/wp-content/uploads/no-image-1024x1024.png" alt="Card-cap" />
                            )
                    }
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip >Add Photo</Tooltip>}
                    >
                        <Link className='add-photo-btn' to="/myPhotos"><HiPlusCircle className='fs-1' /></Link>
                    </OverlayTrigger>
                    <Form.Control
                        type="file"
                        accept="image/*"
                        className="d-none"
                        ref={fileInputRef}
                        onChange={handleFileInputChange}
                    />
                </div>
                <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                        <div className='d-flex justify-content-between align-items-center'>
                            <div>
                                <div className='fw-600 fs-6'>{`${user?.firstName} ${user?.lastName}`}</div>
                                <div className='normal-text'>{user?.userId}</div>
                            </div>
                            <div>
                                <Link to='/edit-personal-profile'><button className='btn-small bold-link'>Edit</button></Link>
                            </div>
                        </div>
                    </li>
                    <li className="list-group-item">
                        <div className='d-flex justify-content-between align-items-center'>
                            <div>
                                <div className='normal-text'>Account Type</div>
                                <div className='normal-text fw-bold'>{user.userStatus?.membership?.membershipType + " Membership"}</div>
                            </div>
                            <div>
                                {user.userStatus?.membership?.membershipType === "Free" && <Link><button className='btn-small bold-link'>Upgrade</button></Link>}
                            </div>
                        </div>
                    </li>
                    <li className="list-group-item">
                        <div className='d-flex justify-content-between align-items-center'>
                            <div>
                                <div className='normal-text'>{user.userStatus.isVerified ? "Account is verified" : "Account is Not Verified"}</div>
                                {!user.userStatus.isVerified && <Link onClick={() => setShow(true)} className='bold-link'><div>Verify your Account</div></Link>}
                            </div>
                            <div>
                                <BsShieldFillCheck className='text-secondary mx-3' />
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </>
    )
}

export default UserCard